// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17HuP","newExpiryDate":"styles_newExpiryDate__qe_nO","footer":"styles_footer__1IT-Q"};